export default __webpack_public_path__ + "static/media/readinessExam.d5a731b5.svg";